import { jsx as t } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { memo as y } from "../../../../../external/preact/compat/dist/compat.module.js";
import { propsProperty as k, property as o } from "./utils.js";
import { CalendarGridRenderToken as L } from "../../types.js";
import { memoComparator as n } from "../../../../../utils/preact/memoComparator/main.js";
import { EMPTY_OBJECT as l } from "../../../../../utils/value/constants.js";
import { getClassName as m } from "../../../../../utils/preact/className.js";
const i = "adyen-pe-calendar__cell adyen-pe-calendar__cell--day-of-week", p = "adyen-pe-calendar__day-of-week", u = (a = l, e) => {
  const s = k.unwrapped(
    {
      childClassName: o.mutable(p),
      childProps: {
        children: o.restricted(),
        className: ""
      },
      className: o.mutable(i),
      props: {
        ...a,
        children: o.restricted(),
        className: ""
      }
    },
    !0
  );
  return e == null || e(L.DAY_OF_WEEK, s), s;
}, A = ({ prepare: a, flags: e, labels: { long: s, short: _ } }) => {
  const d = {
    "aria-label": s,
    "data-first-week-day": e.LINE_START,
    "data-last-week-day": e.LINE_END,
    "data-weekend": e.WEEKEND,
    scope: "col"
  }, r = u(d, a), { children: P, className: N, ...c } = r.props || l, E = m(r.className, i, N), {
    children: D,
    className: f,
    ...h
  } = r.childProps || l, C = m(r.childClassName, p, f);
  return /* @__PURE__ */ t("th", { ...c, ref: c.ref, ...d, className: E, children: /* @__PURE__ */ t("abbr", { ...h, className: C, children: _ }) });
}, G = y(
  A,
  n({
    block: n.exclude,
    flags: (a) => +a
  })
);
export {
  G as default
};
